// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { ROUTE_DEFINITIONS, getPath } from "../../routes/routes";
import React, { useContext, useState } from "react";
import {
  validateEmail,
  validatePasswordLength,
} from "../ui/Questionnaire/validators/QuestionnaireValidators";

import AuthenticationCard from "./AuthenticationCard";
import { CustomerContext } from "components/App/DashboardApp";
import { Link } from "react-router-dom";
import PageContent from "../ui/PageContent";
import { Question } from "../ui/Questionnaire/QuestionnaireTypes";
import QuestionnaireForm from "../ui/Questionnaire/Questionnaire";
import QuestionnaireInput from "components/ui/Questionnaire/QuestionnaireInput";
import { fbt } from "fbt";
import { signin } from "store/auth";

export default () => {
  const [error, setError] = useState<string | null>(null);
  const customerConfig = useContext(CustomerContext);

  const onSubmit = async (
    event: React.FormEvent,
    questions: { [key: string]: Question }
  ) => {
    event.preventDefault();
    const email = questions.email.value;
    const password = questions.password.value;
    try {
      const success = await signin(email!, password!);
      if (!success) {
        // TODO Add Logs.
        throw new Error("Sorry, we were not able to log you in.");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <PageContent>
      <AuthenticationCard
        title={fbt("Sign In", "Title header of sign-in form field.", {
          project: "audere",
        })}
      >
        <QuestionnaireForm
          onSubmit={onSubmit}
          submitLabel={fbt(
            "Login",
            "Button to submit the sign-in form field.",
            {
              project: "audere",
            }
          )}
          error={error}
        >
          <div>
            <fbt desc="login screen detailed introduction text" project="nhs">
              The COVID-19 Antigen Home Testing App is offered by the NHS, and
              enables you to order and conduct a COVID-19 antigen test from the
              comfort of your home.
            </fbt>
          </div>
          <br />
          <QuestionnaireInput
            icon="envelope"
            label={fbt("Email", "Label for the login Email field", {
              project: "audere",
            })}
            mandatory={true}
            name="email"
            placeholder={fbt(
              "Enter your email",
              "Placeholder for the login Email field",
              { project: "audere" }
            )}
            type="email"
            validators={[validateEmail]}
          />
          <QuestionnaireInput
            icon="lock"
            label={fbt("Password", "Label for the login Password field", {
              project: "audere",
            })}
            mandatory={true}
            name="password"
            type="password"
            validators={[validatePasswordLength]}
          />
        </QuestionnaireForm>
        <div>
          <fbt desc="Login footer links" project="audere">
            <Link to={getPath(ROUTE_DEFINITIONS.SIGNUP)}>
              Create an account
            </Link>{" "}
            or{" "}
            <Link to={getPath(ROUTE_DEFINITIONS.FORGOTPASSWORD)}>
              Forgot password?
            </Link>
          </fbt>
        </div>
        {customerConfig.allowGuestRuns && (
          <div>
            <fbt desc="Login guest link" project="audere">
              <Link to={getPath(ROUTE_DEFINITIONS.NEWTESTRUN)}>
                Continue as Guest
              </Link>
            </fbt>
          </div>
        )}
      </AuthenticationCard>
    </PageContent>
  );
};
